<template>
	<validation-observer v-slot="{ invalid }" ref="form" class="form mx-auto">
		<b-form @submit.prevent="submitForm">
			<slot name="header">
				<h4 class="mb-4">Manage Roles</h4>
			</slot>

			<b-form-group label="Role" label-size="lg">
				<validation-provider
					rules="required"
					v-slot="{ errors }"
					name="Role"
				>
					<FormRoleDropdown v-model="models.role_id" />
					<InvalidFeedback :messages="errors" />
				</validation-provider>
			</b-form-group>

			<base-input
				v-model="models.role_value"
				rules="required"
				name="Role Value"
				label="Role Value"
			></base-input>

			<div class="mt-4 d-flex justify-content-between">
				<slot name="return"></slot>
				<slot name="submit">
					<base-button
						:disabled="invalid"
						:loading="formProcessing"
						type="primary"
						native-type="submit"
						size="md"
						class="form-btn font-weight-normal"
						>Save Changes</base-button
					>
				</slot>
			</div>
		</b-form>
	</validation-observer>
</template>

<script>
import FormRoleDropdown from "@components/FormRoleDropdown";
import InvalidFeedback from "@components/InvalidFeedback";

export default {
	name: "form-company-role",
	components: {
		FormRoleDropdown,
		InvalidFeedback,
	},
	inject: ["companySvc", "ErrorService"],
	data() {
		return {
			formProcessing: false,
			models: {},
		};
	},
	watch: {
		"companySvc.company": {
			deep: true,
			immediate: true,
			handler: function (val) {
				this.models = {
					id: val.id,
					name: val.name,
					role_id: val.role.id,
					role_value: val.role_value,
				};
			},
		},
		formProcessing: function (val) {
			this.$bus.$emit("company-role-form-processing", val);
		},
	},
	methods: {
		async submitForm() {
			this.formProcessing = true;

			const response = await this.companySvc.update(this.models);

			if (200 === response.data.status)
				this.$bus.$emit(
					"company-role-form-success",
					response.data.data.data
				);

			this.$toasted.show(response.data.data.message);

			this.reset();
		},
		reset() {
			document.activeElement.blur();

			this.formProcessing = false;
			this.models = {};

			this.$refs.form.reset();
		},
	},
	mounted() {
		this.ErrorService.stopProcessingOnFail(this);
	},
	beforeDestroy() {
		this.companySvc.set("company", null);

		this.reset();
	},
};
</script>
